import { render, staticRenderFns } from "./CreateTermSlidebar.vue?vue&type=template&id=5379f82c"
import script from "./CreateTermSlidebar.vue?vue&type=script&lang=js"
export * from "./CreateTermSlidebar.vue?vue&type=script&lang=js"
import style0 from "./CreateTermSlidebar.vue?vue&type=style&index=0&id=5379f82c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports